import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class DvcBudgetApi extends DIApi {
  controllerName = 'DvcBudgets';

  /**
   * Theo dõi/Ngưng theo dõi
   */
  checkArise(payload) {
    const request = {
      url: this.getAPIUrl() + '/check-arise',
      data: payload,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Cập nhật thiết lặp mã hồ sơ
   * @param {*} payload
   * @returns
   * nhhoang1 12.03.2024
   */
  updateSettingFileCode(payload) {
    const request = {
      url: this.getAPIUrl() + '/setting',
      data: payload,
    };

    return httpClient.postAsync(request);
  }
}

export default new DvcBudgetApi();
